// Shared month normalization utilities

// Returns canonical short month (Jan..Dec) with September as 'Sep'
export function normalizeShortMonth(monthName: string): string {
  const input = (monthName || '').trim();
  const lc = input.toLowerCase();
  const map: Record<string, string> = {
    january: 'Jan', jan: 'Jan',
    february: 'Feb', feb: 'Feb',
    march: 'Mar', mar: 'Mar',
    april: 'Apr', apr: 'Apr',
    may: 'May',
    june: 'Jun', jun: 'Jun',
    july: 'Jul', jul: 'Jul',
    august: 'Aug', aug: 'Aug',
    september: 'Sep', sep: 'Sep', sept: 'Sep',
    october: 'Oct', oct: 'Oct',
    november: 'Nov', nov: 'Nov',
    december: 'Dec', dec: 'Dec'
  };
  return map[lc] || input;
}

// Gets the short month name for a Date and normalizes it
export function getShortMonthName(date: Date): string {
  const raw = date.toLocaleString('default', { month: 'short' });
  return normalizeShortMonth(raw);
}


